import React, { useState } from "react";
import {
  FiMail,
  FiSend,
  FiMessageCircle,
  FiCheckCircle,
  FiAlertCircle,
  FiChevronDown,
} from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { selectMessageLoading } from "../../store/slices/message/slice";
import { createMessage } from "../../store/slices/message/asyncThunks";
import { toast } from "../modern-ui/sonner";

const ContactSectionComponent = () => {
  const dispatch = useDispatch();
  const loading = useSelector(selectMessageLoading);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "",
    message: "",
  });

  const [formStatus, setFormStatus] = useState({
    error: null,
  });

  // Real-time status check for working hours
  // const getCurrentStatus = () => {
  //   const now = new Date();
  //   const day = now.getDay();
  //   const hour = now.getHours();

  //   if (day === 0)
  //     return {
  //       isOpen: false,
  //       status: "Zatvoreno",
  //       nextOpen: "Ponedeljak u 09:00",
  //     };
  //   if (day === 6) {
  //     const isOpen = hour >= 10 && hour < 14;
  //     return {
  //       isOpen,
  //       status: isOpen ? "Otvoreno" : "Zatvoreno",
  //       nextOpen: isOpen ? "Do 14:00" : "Ponedeljak u 09:00",
  //     };
  //   }
  //   if (day >= 1 && day <= 5) {
  //     const isOpen = hour >= 9 && hour < 17;
  //     return {
  //       isOpen,
  //       status: isOpen ? "Otvoreno" : "Zatvoreno",
  //       nextOpen: isOpen ? "Do 17:00" : "Sutra u 09:00",
  //     };
  //   }
  //   return { isOpen: false, status: "Zatvoreno", nextOpen: "Sutra u 09:00" };
  // };

  // const { isOpen, status, nextOpen } = getCurrentStatus();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear error when user starts typing
    if (formStatus.error) {
      setFormStatus((prev) => ({ ...prev, error: null }));
    }
  };

  const validateForm = () => {
    if (!formData.fullName.trim()) return "Ime i Prezime je obavezno";
    if (!formData.email.trim()) return "Email je obavezan";
    if (!/\S+@\S+\.\S+/.test(formData.email))
      return "Email format nije ispravan";
    if (!formData.subject.trim()) return "Tema je obavezna";
    if (!formData.message.trim()) return "Poruka je obavezna";
    if (formData.message.length < 10)
      return "Poruka mora biti duža od 10 karaktera";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const error = validateForm();
    if (error) {
      setFormStatus({ error });
      return;
    }

    dispatch(
      createMessage({
        fullName: formData.fullName,
        email: formData.email,
        subject: formData.subject,
        message: formData.message,
      })
    )
      .unwrap()
      .then(() => {
        toast.success("Uspešno ste poslali poruku admin timu.");

        setFormData({ fullName: "", email: "", subject: "", message: "" });
        setFormStatus({ error: null });
      })
      .catch((err) => console.log(err.message));

    setFormStatus({ error: null });
  };

  return (
    <ContactSection>
      <SectionHeader>
        <SectionTitle>
          <FiMessageCircle />
          Kontaktirajte nas
        </SectionTitle>
        <SectionDescription>
          Kakav god da je razlog - pitanje, savet, biznis predlog ili muzička
          diskusija - ne oklevajte da se javite bilo kojim od ponuđenih načina!
        </SectionDescription>
      </SectionHeader>

      <ContactLayout>
        {/* Contact Info Cards */}
        <ContactInfoSection>
          <ContactGrid>
            {/* Address Card */}
            {/* <ContactCard>
              <CardHeader>
                <ContactIcon>
                  <FiMapPin />
                </ContactIcon>
                <div>
                  <ContactTitle>Naša lokacija</ContactTitle>
                  <ContactSubtitle>Posetite nas u Kragujevcu</ContactSubtitle>
                </div>
              </CardHeader>
              <ContactDetails>
                <AddressLine>Svetozara Markovića 15</AddressLine>
                <AddressLine>34000 Kragujevac, Srbija</AddressLine>
                <MapButton href="https://maps.google.com" target="_blank">
                  <FiExternalLink />
                  Otvori u Google Maps
                </MapButton>
              </ContactDetails>
            </ContactCard> */}

            {/* Phone Card */}
            {/* <ContactCard>
              <CardHeader>
                <ContactIcon>
                  <FiPhone />
                </ContactIcon>
                <div>
                  <ContactTitle>Pozovite nas</ContactTitle>
                  <ContactSubtitle>Brza pomoć i podrška</ContactSubtitle>
                </div>
              </CardHeader>
              <ContactDetails>
                <PhoneLink href="tel:+381341234567">
                  +381 34 123 4567
                  <span>Fiksni telefon</span>
                </PhoneLink>
                <PhoneLink href="tel:+381651234567">
                  +381 65 123 4567
                  <span>Mobilni telefon</span>
                </PhoneLink>
              </ContactDetails>
            </ContactCard> */}

            {/* Email Card */}
            <ContactCard>
              <CardHeader>
                <ContactIcon>
                  <FiMail />
                </ContactIcon>
                <div>
                  <ContactTitle>Email adrese</ContactTitle>
                  <ContactSubtitle>Odgovaramo u roku od 24h</ContactSubtitle>
                </div>
              </CardHeader>
              <ContactDetails>
                <EmailLink href="mailto:info@mrch.rs">
                  info@mrc.rs
                  <span>Opšta pitanja</span>
                </EmailLink>
                <EmailLink href="mailto:podrska@mrch.rs">
                  podrska@mrc.rs
                  <span>Tehnička podrška</span>
                </EmailLink>
              </ContactDetails>
            </ContactCard>

            {/* Working Hours Card */}
            {/* <WorkingHoursCard>
              <CardHeader>
                <ContactIcon>
                  <FiClock />
                </ContactIcon>
                <div>
                  <ContactTitle>Radno vreme</ContactTitle>
                  <StatusBadge $isOpen={isOpen}>
                    <StatusDot $isOpen={isOpen} />
                    {status}
                  </StatusBadge>
                </div>
              </CardHeader>
              <WorkingHoursList>
                <HourItem $highlight={true}>
                  <DayLabel>Ponedeljak - Petak</DayLabel>
                  <TimeLabel>09:00 - 17:00</TimeLabel>
                </HourItem>
                <HourItem>
                  <DayLabel>Subota</DayLabel>
                  <TimeLabel>10:00 - 14:00</TimeLabel>
                </HourItem>
                <HourItem $closed={true}>
                  <DayLabel>Nedelja</DayLabel>
                  <TimeLabel>Zatvoreno</TimeLabel>
                </HourItem>
              </WorkingHoursList>
              {!isOpen && (
                <NextOpenInfo>Sledeće otvaramo: {nextOpen}</NextOpenInfo>
              )}
            </WorkingHoursCard> */}
          </ContactGrid>
        </ContactInfoSection>

        {/* Contact Form */}
        <ContactFormSection>
          <ContactForm onSubmit={handleSubmit}>
            <FormHeader>
              <FormTitle>
                <FiSend />
                Pošaljite nam poruku
              </FormTitle>
              <FormDescription>
                Popunite formu ispod i odgovoriće vam u najkraćem roku
              </FormDescription>
            </FormHeader>

            {formStatus.isSubmitted && (
              <SuccessMessage>
                <FiCheckCircle />
                <div>
                  <strong>Poruka je uspešno poslata!</strong>
                  <p>Odgovoriće vam u najkraćem roku.</p>
                </div>
              </SuccessMessage>
            )}

            {formStatus.error && (
              <ErrorMessage>
                <FiAlertCircle />
                {formStatus.error}
              </ErrorMessage>
            )}

            <FormGrid>
              <FormGroup>
                <FormLabel htmlFor="name">Ime i prezime *</FormLabel>
                <FormInput
                  type="text"
                  id="fullName"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleInputChange}
                  placeholder="Vaše puno ime"
                  $error={formStatus.error && !formData.fullName.trim()}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel htmlFor="email">Email adresa *</FormLabel>
                <FormInput
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="vasa@email.rs"
                  $error={
                    formStatus.error &&
                    (!formData.email.trim() ||
                      !/\S+@\S+\.\S+/.test(formData.email))
                  }
                />
              </FormGroup>
            </FormGrid>

            <FormGroup>
              <FormLabel htmlFor="subject">Tema poruke *</FormLabel>
              <Relative>
                <FormSelect
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  $error={formStatus.error && !formData.subject.trim()}
                >
                  <option value="">Izaberite temu...</option>
                  <option value="Opšta pitanja">Opšta pitanja</option>
                  <option value="Pitanja o porudžbini">
                    Pitanja o porudžbini
                  </option>
                  <option value="Tehnička podrška">Tehnička podrška</option>
                  <option value="Partnerstvo">Partnerstvo</option>
                  <option value="Povratne informacije">
                    Povratne informacije
                  </option>
                  <option value="Ostalo">Ostalo</option>
                </FormSelect>
                <FiChevronDown
                  color="#ff6b35"
                  size={20}
                  style={{
                    position: "absolute",
                    right: 15,
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                />
              </Relative>
            </FormGroup>

            <FormGroup>
              <FormLabel htmlFor="message">Vaša poruka *</FormLabel>
              <FormTextarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Opišite detaljno vaše pitanje ili zahtev..."
                $error={
                  formStatus.error &&
                  (!formData.message.trim() || formData.message.length < 10)
                }
              />
              <CharacterCount $warning={formData.message.length > 500}>
                {formData.message.length}/1000
              </CharacterCount>
            </FormGroup>

            <SubmitButton disabled={loading} $isSubmitting={loading}>
              {loading ? (
                <>
                  <l-line-spinner size="20" stroke="2" speed="1" color="#fff" />
                  Šalje se...
                </>
              ) : (
                <>
                  <FiSend />
                  Pošalji poruku
                </>
              )}
            </SubmitButton>
          </ContactForm>
        </ContactFormSection>
      </ContactLayout>
    </ContactSection>
  );
};

// Styled Components
const ContactSection = styled.section`
  background: #1a1a1a;
  border-radius: 20px;
  padding: 3rem;
  margin-bottom: 3rem;
  border: 1px solid #333;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="0.8" fill="%23ff6b35" opacity="0.08"/><circle cx="75" cy="75" r="1" fill="%23ff6b35" opacity="0.08"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
    opacity: 0.5;
    z-index: 1;
  }

  > * {
    position: relative;
    z-index: 2;
  }

  @media (max-width: 768px) {
    padding: 2rem;
  }

  @media (max-width: 480px) {
    padding: 1.5rem;
  }
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const SectionTitle = styled.h2`
  color: #ff6b35;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  @media (max-width: 768px) {
    font-size: 2rem;
    flex-direction: column;
    gap: 0.5rem;
  }
`;

const SectionDescription = styled.p`
  color: #cccccc;
  font-size: 1.2rem;
  line-height: 1.6;
  max-width: 650px;
  margin: 0 auto;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const ContactLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;

  @media (max-width: 1024px) {
    gap: 3rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const ContactInfoSection = styled.div``;

const ContactGrid = styled.div`
  display: grid;
  gap: 1.5rem;
  margin-bottom: 2rem;
`;

const ContactCard = styled.div`
  background: linear-gradient(145deg, #2c2c2c 0%, #1e1e1e 100%);
  border: 1px solid #444;
  border-radius: 15px;
  padding: 2rem;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    border-color: #ff6b35;
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(255, 107, 53, 0.2);
  }

  @media (max-width: 480px) {
    padding: 1.5rem;
  }
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

const ContactIcon = styled.div`
  color: #ff6b35;
  font-size: 2rem;
  animation: pulse 2s infinite;

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.8;
    }
  }
`;

const ContactTitle = styled.h3`
  color: #ffffff;
  font-size: 1.2rem;
  margin: 0;
  font-weight: bold;
`;

const ContactSubtitle = styled.p`
  color: #999;
  font-size: 0.9rem;
  margin: 0.3rem 0 0 0;
`;

const ContactDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

const EmailLink = styled.a`
  color: #ffffff;
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;

  span {
    color: #999;
    font-size: 0.85rem;
    font-weight: 400;
    margin-top: 0.2rem;
  }

  &:hover {
    color: #ff6b35;
    transform: translateX(3px);
  }
`;

// const StatusBadge = styled.div`
//   display: inline-flex;
//   align-items: center;
//   gap: 0.5rem;
//   padding: 0.3rem 0.8rem;
//   border-radius: 20px;
//   font-size: 0.8rem;
//   font-weight: 600;
//   text-transform: uppercase;
//   background: ${(props) =>
//     props.$isOpen
//       ? "linear-gradient(135deg, #27ae60, #2ecc71)"
//       : "linear-gradient(135deg, #e74c3c, #c0392b)"};
//   color: white;
// `;

// const StatusDot = styled.div`
//   width: 6px;
//   height: 6px;
//   border-radius: 50%;
//   background: white;
//   animation: ${(props) => (props.$isOpen ? "blink 1.5s infinite" : "none")};

//   @keyframes blink {
//     0%,
//     100% {
//       opacity: 1;
//     }
//     50% {
//       opacity: 0.3;
//     }
//   }
// `;

// const WorkingHoursList = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 0.8rem;
// `;

// const HourItem = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   padding: 0.8rem;
//   border-radius: 8px;
//   background: ${(props) =>
//     props.$highlight ? "rgba(255, 107, 53, 0.1)" : "rgba(255, 255, 255, 0.03)"};
//   border: 1px solid
//     ${(props) =>
//       props.$highlight
//         ? "rgba(255, 107, 53, 0.3)"
//         : "rgba(255, 255, 255, 0.05)"};
// `;

// const DayLabel = styled.span`
//   color: #ffffff;
//   font-weight: 500;
//   font-size: 0.9rem;
// `;

// const TimeLabel = styled.span`
//   color: ${(props) => (props.$closed ? "#e74c3c" : "#ff6b35")};
//   font-weight: 600;
//   font-size: 0.9rem;
// `;

// const NextOpenInfo = styled.div`
//   margin-top: 1rem;
//   padding: 0.8rem;
//   border-radius: 8px;
//   background: rgba(255, 193, 7, 0.1);
//   border: 1px solid rgba(255, 193, 7, 0.2);
//   color: #ffc107;
//   font-size: 0.85rem;
//   text-align: center;
//   font-style: italic;
// `;

const ContactFormSection = styled.div``;

const ContactForm = styled.form`
  position: sticky;
  top: 1.5rem;

  background: linear-gradient(145deg, #2c2c2c 0%, #1e1e1e 100%);
  border: 1px solid #444;
  border-radius: 20px;
  padding: 2.5rem;

  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(90deg, #ff6b35, #e55a2b);
    border-radius: 20px 20px 0 0;
  }

  @media (max-width: 480px) {
    padding: 2rem;
  }
`;

const FormHeader = styled.div`
  margin-bottom: 2rem;
`;

const FormTitle = styled.h3`
  color: #ff6b35;
  font-size: 1.6rem;
  margin-bottom: 0.5rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 0.8rem;

  @media (max-width: 480px) {
    font-size: 1.4rem;
    flex-direction: column;
    gap: 0.5rem;
  }
`;

const FormDescription = styled.p`
  color: #999;
  font-size: 1rem;
  margin: 0;
`;

const SuccessMessage = styled.div`
  background: linear-gradient(135deg, #27ae60, #2ecc71);
  color: white;
  padding: 1.5rem;
  border-radius: 12px;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  animation: slideIn 0.5s ease;

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  svg {
    font-size: 1.5rem;
    flex-shrink: 0;
  }

  strong {
    display: block;
    margin-bottom: 0.3rem;
  }

  p {
    margin: 0;
    font-size: 0.9rem;
    opacity: 0.9;
  }
`;

const ErrorMessage = styled.div`
  background: rgba(231, 76, 60, 0.1);
  border: 1px solid #e74c3c;
  color: #e74c3c;
  padding: 0.8rem 1rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-size: 1rem;
  display: flex;
  align-items: center;
  flex-direction: row;

  gap: 5px;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

const Relative = styled.div`
  position: relative;
`;

const FormLabel = styled.label`
  display: block;
  color: #ffffff;
  font-weight: 600;
  margin-bottom: 0.8rem;
  font-size: 1rem;
`;

const FormInput = styled.input`
  width: 100%;
  background: #1a1a1a;
  border: 2px solid ${(props) => (props.$error ? "#e74c3c" : "#444")};
  border-radius: 10px;
  padding: 1rem;
  color: #ffffff;
  font-size: 1rem;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: ${(props) => (props.$error ? "#e74c3c" : "#ff6b35")};
    box-shadow: 0 0 0 3px
      ${(props) =>
        props.$error ? "rgba(231, 76, 60, 0.1)" : "rgba(255, 107, 53, 0.1)"};
  }

  &::placeholder {
    color: #666;
  }
`;

const FormSelect = styled.select`
  width: 100%;
  background: #1a1a1a;
  border: 2px solid ${(props) => (props.$error ? "#e74c3c" : "#444")};
  border-radius: 10px;
  padding: 1rem;
  color: #ffffff;
  font-size: 1rem;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: ${(props) => (props.$error ? "#e74c3c" : "#ff6b35")};
    box-shadow: 0 0 0 3px
      ${(props) =>
        props.$error ? "rgba(231, 76, 60, 0.1)" : "rgba(255, 107, 53, 0.1)"};
  }

  option {
    background: #1a1a1a;
    color: #ffffff;
  }
`;

const FormTextarea = styled.textarea`
  width: 100%;
  background: #1a1a1a;
  border: 2px solid ${(props) => (props.$error ? "#e74c3c" : "#444")};
  border-radius: 10px;
  padding: 1rem;
  color: #ffffff;
  font-size: 1rem;
  min-height: 120px;
  max-height: 300px;
  resize: vertical;
  transition: all 0.3s ease;
  font-family: inherit;

  &:focus {
    outline: none;
    border-color: ${(props) => (props.$error ? "#e74c3c" : "#ff6b35")};
    box-shadow: 0 0 0 3px
      ${(props) =>
        props.$error ? "rgba(231, 76, 60, 0.1)" : "rgba(255, 107, 53, 0.1)"};
  }

  &::placeholder {
    color: #666;
  }
`;

const CharacterCount = styled.div`
  text-align: right;
  font-size: 0.8rem;
  color: ${(props) => (props.$warning ? "#ffc107" : "#999")};
  margin-top: 0.5rem;
`;

const SubmitButton = styled.button`
  background: ${(props) =>
    props.$isSubmitting
      ? "linear-gradient(135deg, #999, #666)"
      : "linear-gradient(135deg, #ff6b35, #e55a2b)"};
  color: #ffffff;
  border: none;
  border-radius: 12px;
  padding: 1.2rem 2.5rem;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: ${(props) => (props.$isSubmitting ? "not-allowed" : "pointer")};
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  width: 100%;

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #e55a2b, #ff6b35);
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(255, 107, 53, 0.3);
  }

  &:disabled {
    opacity: 0.7;
  }
`;

export default ContactSectionComponent;
